import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { Box, CircularProgress } from '@mui/material';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#222226' }}>
        <CircularProgress sx={{ color: '#8F7BE0' }} />
      </Box>
    );
  }

  // Allow access if user is authenticated OR if a username is provided (secret access)
  if (!user && !searchParams.get('username')) return <Navigate to="/login" replace />;

  return children;
}
